exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text[data-v-7aeb2a40]{\n  padding:1em;\n}\n.drag-area[data-v-7aeb2a40]{\n\n  display: block;\n  width: 100%;\n  background-color:rgba(28, 133, 154, .05);\n}\n.gray[data-v-7aeb2a40]{\n   background-color:rgba(28, 133, 154, 1);\n}\n.salmon[data-v-7aeb2a40]{\n  background-color:rgba(28, 133, 154, .05);\n}\nbutton[data-v-7aeb2a40]{\n  border: none;\n  background-color: #1c869a;\n  width: 49%;\n  margin: 1em auto;\n  padding: 1em;\n  color: white;\n  font-family: 'Noto Sans KR', sans-serif;\n  text-transform: uppercase;\n}\n.underline[data-v-7aeb2a40]{\n  text-decoration: underline;\n}\n", ""]);

// exports
